import React,{useRef,useState} from "react";
import HeroSection from "./../components/HeroSection";
import FeaturesSection from "./../components/FeaturesSection";
import CtaSection from "./../components/CtaSection";
import { useRouter } from "./../util/router.js";

function IndexPage(props) {
  const router = useRouter();
  const phoneInputRef = useRef(null);
  const zipInputRef = useRef(null);
  const [showInput,setShowInput] = useState(true);

  function handleSubmit(){
    var phone;
    var zip;
    try{
      phone = phoneInputRef.current.value;
      zip = zipInputRef.current.value;

    }catch(e){
      console.log(e)
    }

    if(phone != '' && zip != ''){
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zip: zip , phone:phone})
      };
      fetch('https://us-central1-covidsms.cloudfunctions.net/app/api/subscribe', requestOptions)
          .then(data => {console.log(data);setShowInput(false)});
    }


    //"https://us-central1-covidsms.cloudfunctions.net/app/api/subscribe"

  }

  return (
    <>
      <HeroSection
        color="primary"
        size="large"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Covid Crowdsource"
        subtitle="A crowdsourced initiative led by city volunteers so you get updated Covid-19 info via text. Get news, testing center locations, and info on hotlines. "
        buttonText="SIGN UP"
        phoneInputRef={phoneInputRef}
        zipInputRef={zipInputRef}
        showInput={showInput}
        buttonOnClick={() => {
          // Navigate to pricing page
          handleSubmit();
        }}
      ></HeroSection>
      <FeaturesSection
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="What we're working on"
        subtitle="The most relevant text updates."
      ></FeaturesSection>
      <CtaSection
        color="primary"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Want to get involved and help crowdsource?"
        buttonText="SIGN UP"
        buttonOnClick={() => {
          // Navigate to pricing page
          router.push("/crowd-source");
        }}
      ></CtaSection>
    </>
  );
}

export default IndexPage;
